import React from 'react';
import FormulaireAssociation from '../components/FormulaireAssociation';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <FormulaireAssociation />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
